var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-wrapper"},[_c('div',{staticClass:"sticky-inner"},[_c('accept-decline',{attrs:{"campaign":_vm.campaign,"owner":_vm.owner}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }